export default function InlineCode({ children }) {
  return (
    <code className="inline bg-whisper text-cornflower p-1 rounded">
      {children}
    </code>
  );
}
